// Geteilte Farb-/Stil-Konstanten für den internen Chat — wärmere „Teamchat"-Palette
// (Creme/dunkles Plum/Gold) im kvp-rd-Theme.
export const AUB = "#4d2051";
export const INK = "#241522";
export const INK2 = "#6b5a66";
export const LINE = "#ece7f0";
export const BG_SOFT = "#fbf9fc";
export const BG_REPLY = "#f7f5fa";

/** Einheitliche horizontale Flucht des Thread-Bereichs (Header, Nachrichtenfläche
 *  und Composer-Wrapper) — damit Thread-Kante, Titel und Eingabe exakt fluchten. */
export const CHAT_PAD_X = 16;

/** Dunkles Plum — eigene Sprechblase, aktiver Tab, Senden-Button. */
export const PLUM = "#3a1d3a";
/** Gold/Amber — Unread-Badges & Aktiv-Akzent (statt Rot). */
export const GOLD = "#e0a01e";
/** Warme Creme — aktive Konversationszeile. */
export const CREAM = "#fbf1e3";
/** Hintergrund fremder Sprechblasen. */
export const BUBBLE_OTHER = "#f1eef1";

/** Warmes Hellgrau — Hintergrund der Sidebar-/Listen-Spalte. */
export const SIDEBAR_BG = "#f6f4f6";
/** Warmes Off-White — Hintergrund der Nachrichtenfläche (nur Scrollbereich). */
export const THREAD_BG = "#f4f1ee";
/** Pfirsich — aktive Konversationszeile in der Sidebar. */
export const ACTIVE_BG = "#f9efe3";

/** Deterministische, ruhige Avatar-Farben (an den Mockup angelehnt). */
export const AVATAR_COLORS = [
  "#c25b58",
  "#8a8a8a",
  "#5b7fb5",
  "#5fa37e",
  "#c9a34e",
  "#7d5ba6",
  "#cf7d3c",
  "#4d8b8b",
];
export function avatarColor(seed: string): string {
  let h = 0;
  for (let i = 0; i < seed.length; i++) h = (h * 31 + seed.charCodeAt(i)) >>> 0;
  return AVATAR_COLORS[h % AVATAR_COLORS.length];
}
export function initials(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (!parts.length) return "?";
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

/** Team-Kürzel für den Avatar (analog zum vr-bo-Chip in ContactTableRedesign):
 *  „Team "-Präfix weg, dann bei mehreren Wörtern deren Anfangsbuchstaben (max. 3),
 *  sonst die ersten 3 Zeichen. */
/** Anzeigename einer Gruppe: die automatischen Rollen-Gruppen heißen in der DB
 *  „gfgl"/„service" (daran hängt der RBAC-Ausschluss), gezeigt werden sie groß. */
export function gruppenName(name: string | null | undefined): string {
  const n = (name ?? "").trim();
  return /^(gfgl|service)$/i.test(n) ? n.toUpperCase() : n;
}

export function teamKuerzel(name: string): string {
  const n = (name ?? "").replace(/^Team\s+/i, "").trim();
  if (!n) return "#";
  const words = n.split(/\s+/).filter((w) => w && w !== "&");
  if (words.length >= 2) return words.slice(0, 3).map((w) => w[0]!.toUpperCase()).join("");
  return n.slice(0, 3);
}

export const fmtDateTime = (iso?: string): string => {
  if (!iso) return "";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "";
  return d.toLocaleString("de-DE", {
    day: "numeric",
    month: "numeric",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

export const fmtTime = (iso?: string): string => {
  if (!iso) return "";
  const d = new Date(iso);
  return Number.isNaN(d.getTime())
    ? ""
    : d.toLocaleTimeString("de-DE", { hour: "2-digit", minute: "2-digit" });
};

/** Relativer Zeitstempel für die Conversation-Liste: heute = HH:MM,
 *  gestern = „Gestern", letzte 7 Tage = Wochentag (Mo/Di/…), älter = TT.MM. */
export const fmtListTime = (iso?: string | null): string => {
  if (!iso) return "";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "";
  const startOf = (x: Date) =>
    new Date(x.getFullYear(), x.getMonth(), x.getDate()).getTime();
  const dayDiff = Math.round((startOf(new Date()) - startOf(d)) / 86400000);
  if (dayDiff <= 0)
    return d.toLocaleTimeString("de-DE", { hour: "2-digit", minute: "2-digit" });
  if (dayDiff === 1) return "Gestern";
  if (dayDiff < 7) return d.toLocaleDateString("de-DE", { weekday: "short" }).replace(".", "");
  return d.toLocaleDateString("de-DE", { day: "2-digit", month: "2-digit" });
};

export const fmtDayLabel = (iso?: string): string => {
  if (!iso) return "";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "";
  const today = new Date();
  const yest = new Date();
  yest.setDate(today.getDate() - 1);
  const sameDay = (a: Date, b: Date) =>
    a.getFullYear() === b.getFullYear() &&
    a.getMonth() === b.getMonth() &&
    a.getDate() === b.getDate();
  if (sameDay(d, today)) return "Heute";
  if (sameDay(d, yest)) return "Gestern";
  return d.toLocaleDateString("de-DE", { day: "numeric", month: "long", year: "numeric" });
};
